<template>
    <div class="name-card round-corner">
        <Panel
                class="user-panel"
                v-if="userData"
                :img="getAvatarByUUID(userData.uuid)"
                :title="userData.userName"
                :descArr="descArr"
                :btnArr="btnArr"
                @msgClick="msgHandler"
                @wechatClick="wechatHandler"
                @editClick="onEditClick"
        />

        <van-dialog v-model="showMessageDialog" title="发消息" show-cancel-button confirm-button-text="发送" @confirm="confirmHandler">
            <van-field
                    v-model="message"
                    rows="3"
                    :autosize="false"
                    type="textarea"
                    maxlength="120"
                    placeholder="请输入消息"
                    show-word-limit
            />
        </van-dialog>
    </div>
</template>

<script>
    import {Dialog, Field, Toast} from 'vant'
    import {assignIn} from "lodash-es"
    import {env, getAvatarByUUID} from '@/utils/commons'
    import {queryUser} from "@/api"
    import {queryLoginPath, sendMessage} from "@/api/name-card"
    import Panel from '@/components/Panel/Panel'
    import {getPlatformInstance} from "@/platforms"

    export default {
        name: 'NameCard',
        components: {
            [Dialog.Component.name]: Dialog.Component,
            [Field.name]: Field,
            Panel,
        },
        props: ['uuid', 'showEdit'],
        data() {
            return {
                userData: null,
                showMessageDialog: false,
                message: '',
            }
        },
        computed: {
            btnArr() {
                let btnArr = [{text: '发消息', event: 'msgClick'}]
                if (env.wechat) btnArr.push({text: '和TA微信', event: 'wechatClick'})

                if (this.showEdit) btnArr = [{text: '编辑个人信息', event: 'editClick'}]

                return btnArr
            },
            descArr() {
                return [
                    {key: '编号', value: this.userData.humanCode},
                    {key: '电话', value: this.userData.telMobile1, link: `tel:${this.userData.telMobile1}`},
                    {key: '部门', value: this.userData.unitName},
                ]
            },
        },
        created() {
            queryUser(this.uuid).then(resp => {
                this.userData = resp
            })
        },
        methods: {
          getAvatarByUUID,
            msgHandler() {
                this.showMessageDialog = true
            },
            wechatHandler() {
                getPlatformInstance().then(platform => platform.openChat(this.userData.userId))
            },
            confirmHandler() {
                const message = this.message.trim()
                if (!message) return Toast('请输入消息')

                this.message = ''
                Promise.all([queryUser(), queryLoginPath()])
                    .then(([user, path]) => sendMessage({
                        receiverId: this.uid,
                        content: message.trim(),
                        sender: assignIn({path: path.wxLoginPath}, user)
                    }))
                    .then(resp => {
                        if (resp == 'ok') Toast('消息发送成功')
                        else Toast('消息发送失败')
                    })
            },
            onEditClick(){
                this.$router.push({path: '/addressBook/editPersonalInfo'})
            },
        },
    }
</script>

<style scoped lang="scss">
    .user-panel {
        margin: 10px 15px;
    }
</style>
